const downLoadSelect = document.querySelectorAll(".download-select");
if (downLoadSelect) {
  downLoadSelect.forEach((select) => {
    // if nothing is selected, select the first option
    const firstOption = select.querySelector("option");
    if (firstOption) {
      firstOption.parentElement?.nextElementSibling?.setAttribute("href", firstOption.value);
    }
    //$(select).niceSelect().val(); // Initialize the Nice Select plugin on the select element
    
    $(select).niceSelect().on('change', function (e) {
      select?.nextElementSibling?.nextElementSibling?.setAttribute("href", $(select).niceSelect().val());
    });
    select.addEventListener("change", (e) => {
      
      const select = e.target as HTMLSelectElement;
      const value = select.value || "";
      const downloadBtn = select.nextElementSibling;
      if (downloadBtn) {
        downloadBtn.setAttribute("href", value);
      }
    });
  });
}
